import { useTranslation } from "react-i18next";
import Dropdown from "react-bootstrap/Dropdown";
import { SORT_TYPE } from "../../constants";
import { Column } from "../List/List";

export interface SortProperty {
  propertyName: string;
  type: string;
}

interface SortingSelectorProps {
  columns: Array<Column>;
  currentSort: SortProperty;
  onSortChange: Function;
}

const isItemActive = (
  currentSort: SortProperty,
  column: Column,
  sortType: string
) => {
  return (
    currentSort.propertyName === column.propertyName &&
    currentSort.type === sortType
  );
};

const getDropdownItems = (
  columns: Array<Column>,
  currentSort: SortProperty,
  onSortChange: Function,
  t: any
) => {
  let dropdownItems = [];
  let key = 0;
  for (let column of columns) {
    if (column.sortable) {
      dropdownItems.push(
        <Dropdown.Item
          key={key}
          active={isItemActive(currentSort, column, SORT_TYPE.ASCENDING)}
          onClick={() => {
            onSortChange(column.propertyName, SORT_TYPE.ASCENDING);
          }}
        >
          {t(column.headerName)} - {t("Ascending")}
        </Dropdown.Item>
      );
      key++;

      dropdownItems.push(
        <Dropdown.Item
          key={key}
          active={isItemActive(currentSort, column, SORT_TYPE.DESCENDING)}
          onClick={() => {
            onSortChange(column.propertyName, SORT_TYPE.DESCENDING);
          }}
        >
          {t(column.headerName)} - {t("Descending")}
        </Dropdown.Item>
      );
      key++;
    }
  }
  return dropdownItems;
};

export default function SortingSelector(props: SortingSelectorProps) {
  const { t } = useTranslation();

  return (
    <Dropdown.Menu>
      {getDropdownItems(
        props.columns,
        props.currentSort,
        props.onSortChange,
        t
      )}
    </Dropdown.Menu>
  );
}
